export const UPDATE_CURRENT_START = 'notification/UPDATE_CURRENT_START';
export const UPDATE_CURRENT_FAILED = 'notification/UPDATE_CURRENT_FAILED';
export const UPDATE_CURRENT_COMPLETED = 'notification/UPDATE_CURRENT_COMPLETED';

export const SAVE_CURRENT_START = 'notification/SAVE_CURRENT_START';
export const SAVE_CURRENT_COMPLETED = 'notification/SAVE_CURRENT_COMPLETED';
export const SAVE_CURRENT_FAILED = 'notification/SAVE_CURRENT_FAILED';

export const FETCH_NOTIFICATIONS_START = 'notification/FETCH_NOTIFICATIONS_START';
export const FETCH_NOTIFICATIONS_COMPLETED = 'notification/FETCH_NOTIFICATIONS_COMPLETED';
export const FETCH_NOTIFICATIONS_FAILED = 'notification/FETCH_NOTIFICATIONS_FAILED';

export const MARK_READ_START = 'notification/MARK_READ_START';
export const MARK_READ_COMPLETED = 'notification/MARK_READ_COMPLETED';
export const MARK_READ_FAILED = 'notification/MARK_READ_FAILED';

export const MARK_ALL_READ_START = 'notification/MARK_ALL_READ_START';
export const MARK_ALL_READ_COMPLETED = 'notification/MARK_ALL_READ_COMPLETED';
export const MARK_ALL_READ_FAILED = 'notification/MARK_ALL_READ_FAILED';
